import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-portals.svg'

const PortalSyncsBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Portals Syncs</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      No portal syncs to display. Portal syncs will appear here once
      you have Published a campaign and have performed an export or import.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default PortalSyncsBlankState
